import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import cookie from '@assets/js/public/Cookie'
import device from '@assets/js/public/Device'
import bridge from '@assets/js/public/Bridge'
import './permission'
import '@assets/js/public/Application'
import '@assets/js/public/UrlConfig'
import '@assets/js/public/BeforeEach'
import '@assets/css/public/Query.css'
import httpUtils from '@/utils/http-utils'
import "lib-flexible/flexible.js"
import wx from 'weixin-js-sdk'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import visit from '@/visitor.js'
import Vuex from 'vuex';
import vuexI18n from 'vuex-i18n';
const translationsEn = {
  "content": "This is some {type} content"
};
import Echarts from 'echarts';
Vue.prototype.$echarts = Echarts
 Vue.use(Vuex);
Vue.use(vuexI18n.plugin, store)

Vue.use(ElementUI)
Vue.prototype.axios = axios
Vue.prototype.wx = wx
Vue.prototype.logger = visit
Vue.prototype.$cookie = cookie
Vue.prototype.$device = device
Vue.prototype.$bridge = bridge
Vue.prototype.$httpUtils = httpUtils
Vue.config.productionTip = false


Vue.i18n.add('en', translationsEn);
Vue.i18n.set('en');

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
